/**
 * Muted salon service accents for calendar appointment cards.
 * Cohesive palette — not a rainbow.
 */

const SERVICE_ACCENTS = {
  hair: { border: '#8B7355', bg: 'rgba(139, 115, 85, 0.08)' },
  colour: { border: '#7A6B8A', bg: 'rgba(122, 107, 138, 0.09)' },
  color: { border: '#7A6B8A', bg: 'rgba(122, 107, 138, 0.09)' },
  nails: { border: '#9A6B7A', bg: 'rgba(154, 107, 122, 0.09)' },
  facial: { border: '#6B8A7A', bg: 'rgba(107, 138, 122, 0.09)' },
  skin: { border: '#6B8A7A', bg: 'rgba(107, 138, 122, 0.09)' },
  massage: { border: '#6B7A8A', bg: 'rgba(107, 122, 138, 0.09)' },
  makeup: { border: '#A07A6B', bg: 'rgba(160, 122, 107, 0.09)' },
  bridal: { border: '#8A6D42', bg: 'rgba(138, 109, 66, 0.1)' },
  default: { border: '#8A7A68', bg: 'rgba(138, 122, 104, 0.07)' },
}

/**
 * @param {import('@/types/api').Appointment} appointment
 */
export function serviceAccentForAppointment(appointment) {
  const categoryName = (
    appointment.services?.[0]?.service?.category?.name ??
    appointment.services?.[0]?.service?.commission_category ??
    appointment.services?.[0]?.service?.name ??
    ''
  ).toLowerCase()

  for (const [key, accent] of Object.entries(SERVICE_ACCENTS)) {
    if (key !== 'default' && categoryName.includes(key)) {
      return accent
    }
  }

  return SERVICE_ACCENTS.default
}
